export default __webpack_public_path__ + "static/media/clark-street-merc.dc3bce9e.jpg";